@if (item) {
  <a
    class="nav-item"
    [attr.data-cy]="item.dataCy"
    [routerLink]="item.link"
    [routerLinkActive]="['active']"
    (click)="closeMenu.emit()">
    {{ item.title | transloco }}
  </a>
}
